import { Injectable } from '@angular/core';
import {HttpInterceptor, HttpHandler, HttpRequest} from '@angular/common/http';

import {Router} from '@angular/router';
import {catchError} from 'rxjs/internal/operators';
import { throwError } from 'rxjs';
import { FeedbackService } from '@shared/services/feedback-service';
import { environment } from '@env/environment';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(private router: Router, private feedback: FeedbackService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {

    return next.handle(req).pipe(catchError(error => {
      switch (error.status) {
        case 400: {
          if (error.error.validations && error.error.validations.length) {
            for (let i = 0; i < error.error.validations.length; i++) {
              this.feedback.error(error.error.validations[i]);
            }
          } else {
            this.feedback.error(error.error.message);
          }
          break;
        }
        case 404: {
          this.router.navigate(['error/404']);
          break;
        }
        case 403: {
          this.router.navigate(['error/403']);
          break;
        }
        case 500: {
          if(environment.production){
            this.router.navigate(['error/500'], {queryParams: {code: error.error.hash}});
          } else {
            this.feedback.error('Ocorreu um erro inesperado na aplicação. Verifique o log do navegador.')
          }
          break;
        }
      }
      return throwError(error);
    }));
  }
}
